import { useState } from 'react';
import "./faq.css";

const faqs = [
  {
    q: "How long does an engagement typically take?",
    a: "Most projects are scoped and delivered in 2–6 weeks depending on complexity. Unlike agencies, I don't pad timelines you'll know the exact scope before we start."
  },
  {
    q: "I'm not sure which track applies to me. Where do I start?",
    a: "The discovery call. You don't need to figure it out beforehand that's what the first conversation is for. Most people land somewhere between two tracks anyway."
  },
  {
    q: "Do I need to have my processes documented before we work together?",
    a: "No. Most clients come in with nothing written down. Part of what I do is extract, map, and structure what's in people's heads before we build anything."
  },
  {
    q: "What happens after you build something do you hand it off or stay involved?",
    a: "Every delivery includes documentation and a handoff session so your team can own it. Ongoing support is available if needed, but the goal is always to leave you self-sufficient."
  },
  {
    q: "How is this different from hiring a freelancer or an agency?",
    a: "A freelancer executes what you tell them. An agency sells you a retainer. I come in as a consultant first I'll tell you what actually needs building, which is often different from what you think needs building. Big 4 rigour, without the Big 4 timeline or price tag."
  },
  {
    q: "What does the discovery call actually involve?",
    a: "It's a 30 minute conversation — no pitch, no deck. I ask about your current setup, where the friction is, and what you've already tried. By the end you'll have a clearer picture of what's worth fixing, whether we work together or not."
  },
  {
    q: "Do you work with companies that already have an IT team?",
    a: "Yes. I work alongside internal teams regularly. My job is to move fast on the things that are stuck, not to replace the people already there."
  },
  {
    q: "We're not a tech company. Is this still relevant?",
    a: "That's often where the biggest gains are. Non-tech businesses tend to have the most manual overhead and the least system structure — which means the most room to improve quickly."
  },
  {
    q: "How do you charge for your work?",
    a: "Engagements are scoped and fixed — you know the cost before anything starts. No open-ended retainers, no hourly billing that runs away from you."
  },
  {
    q: "Do you sign NDAs?",
    a: "Yes, always. Everything discussed is treated as confidential from the first call."
  },
  {
    q: "What if the scope changes once we've started?",
    a: "It happens. If something grows beyond the original scope we have a conversation about it before anything changes — you're never surprised by extra costs."
  }
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="faq section" id="faq">
      <h2 className="section__title">FAQ</h2>
      <span className="section__subtitle">Common questions, straight answers.</span>

      <div className="faq__list container">
        {faqs.map((item, i) => (
          <div
            key={i}
            className={`faq__item${openIndex === i ? ' faq__item--open' : ''}`}
          >
            <button className="faq__question" onClick={() => toggle(i)}>
              <span>{item.q}</span>
              <span className="faq__icon">{openIndex === i ? '−' : '+'}</span>
            </button>
            {openIndex === i && (
              <p className="faq__answer">{item.a}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Faq;
